import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { symbolIndexWorkerClient } from '../worker/client.js';
import { normalizeSymbolIndexRelPath } from '../lifecycle/normalize-symbol-index-path.js';

export async function updateSymbolIndexForFile(
  parentPath: string,
  changedPath: string,
): Promise<void> {
  const relPath = normalizeSymbolIndexRelPath(parentPath, changedPath);
  if (relPath == null) return;
  const resolved = normalizeResolvedPath(parentPath);
  await symbolIndexWorkerClient.updateFile(resolved, relPath);
}

export async function removeSymbolIndexForFile(parentPath: string, changedPath: string): Promise<void> {
  const relPath = normalizeSymbolIndexRelPath(parentPath, changedPath);
  if (relPath == null) return;
  const resolved = normalizeResolvedPath(parentPath);
  await symbolIndexWorkerClient.removeFile(resolved, relPath);
}
